
import React from 'react';
import './App.css';
import './css/output.css';
import Login from './authentication/Login';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { isProvider, isCoownership, isRentalManager, mustChooseCoownership, useUser } from './contexts/UserContext';
import Menu from './menu/Menu';
import BottomMenu from './menu/BottomMenu';
import Dashboard from './dashboard/Dashboard';
import ChooseCoownership from './coownership/ChooseCoownership';
import SignUp from './authentication/Signup';
import CoownershipRedirect from './coownership/CoownershipRedirect';
import Loader from './components/Loader';
import AcceptConditionsModal from './authentication/AcceptConditionsModal';
import SavingsSimulatorPage from './simulator/SavingsSimulatorPage';

function AppLayout({ connected, children }) {
  const location = useLocation();
  const isSimulatorPage = location.pathname === '/simulateur';

  return (
    <>
      {!isSimulatorPage && <Menu connected={connected} />}
      {children}
      {!isSimulatorPage && <BottomMenu />}
    </>
  );
}

function AppRoutes({ user }) {
  if (user.user != null && mustChooseCoownership(user.user)) {
    return (
      <AppLayout connected={user.user != null}>
        <Routes>
          <Route path="/simulateur" element={<SavingsSimulatorPage />} />
          <Route path="/" element={<ChooseCoownership />} />
          <Route path="/dashboard" element={<ChooseCoownership />} />
          <Route path="/coownership" element={<ChooseCoownership />} />
        </Routes>
      </AppLayout>
    );
  }

  return (
    <AppLayout connected={user.user != null}>
      {user.user == null ? (
        <Routes>
          <Route path="/simulateur" element={<SavingsSimulatorPage />} />
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/simulateur" element={<SavingsSimulatorPage />} />
          <Route path="/" element={<Dashboard />} />
          {isCoownership(user.user) || isProvider(user.user) || isRentalManager(user.user) ? (
            <Route path='/coownership' element={<ChooseCoownership />}/>
          ) : null }
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/billboard/:coownershipId" element={<CoownershipRedirect menu='affichages' />} />
          <Route path="/events/:coownershipId" element={<CoownershipRedirect menu='evenements'/>} />
          <Route path="/surveys/:coownershipId" element={<CoownershipRedirect menu='sondages'/>} />
          <Route path="/claims/:coownershipId" element={<CoownershipRedirect menu='reclamations'/>} />
        </Routes>
      )}
    </AppLayout>
  );
}

function App() {
  const user = useUser();

  const mustAcceptConditions =
    user.user != null &&
    isCoownership(user.user) &&
    user.user.userData?.acceptConditions !== true;

  if (user.isLoading) {
    return <div className='flex h-screen justify-center'><Loader /></div>;
  }

  return (
    <>
      <Router>
        <AppRoutes user={user} />
      </Router>
      {mustAcceptConditions && <AcceptConditionsModal />}
    </>
  );
}

export default App;
